export default __webpack_public_path__ + "static/media/popfx.e2896b49.mp3";